import api from "./api";

const activityLogService = {
  // Get paginated activity logs with filters
  getActivityLogs: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.role_name) params.append("role_name", filters.role_name);
    if (filters.user_id) params.append("user_id", filters.user_id);
    if (filters.entity_type) params.append("entity_type", filters.entity_type);
    if (filters.search) params.append("search", filters.search);
    if (filters.start_date) params.append("start_date", filters.start_date);
    if (filters.end_date) params.append("end_date", filters.end_date);
    if (filters.limit) params.append("limit", filters.limit);
    if (filters.offset !== undefined) params.append("offset", filters.offset);

    const response = await api.get(`/api/activity-logs?${params.toString()}`);
    return response.data;
  },

  // Get distinct roles and entity types for filter dropdowns
  getFilters: async () => {
    const response = await api.get("/api/activity-logs/filters");
    return response.data;
  },
};

export default activityLogService;
